// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#nav[data-v-738d1602]{width:200px;height:-webkit-min-content;height:-moz-min-content;height:min-content;z-index:2}", ""]);
// Exports
module.exports = exports;
